import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Text = styled.span`
  margin-left: ${layout.spacing.xSmall};
`;
